import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installImageFallback } from '@/utils/imageFallback'
import { ensureGoogleAnalytics } from '@/utils/ga'

// Serve images from /uploads first, and transparently fall back to the CDN
// copy if a local file is missing.
installImageFallback()

// Guarantee the Google tag is loaded even if the static snippet is missing.
ensureGoogleAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
